import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
  },
  statsRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  statBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    minWidth: 140,
    flexShrink: 0,
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  chip: {
    fontWeight: 600,
    minWidth: 40,
    justifyContent: 'center',
  },
  chipDefault: {
    borderColor: theme.palette.grey[400],
    color: theme.palette.grey[700],
    '& .MuiChip-label': {
      color: theme.palette.grey[700],
    },
  },
  chipSuccess: {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
    '& .MuiChip-label': {
      color: theme.palette.success.main,
    },
  },
  chipSecondary: {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    '& .MuiChip-label': {
      color: theme.palette.secondary.main,
    },
  },
  chipInfo: {
    borderColor: theme.palette.info.main,
    color: theme.palette.info.main,
    '& .MuiChip-label': {
      color: theme.palette.info.main,
    },
  },
  chipWarning: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
    '& .MuiChip-label': {
      color: theme.palette.warning.main,
    },
  },
  periodStatInner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  periodDetail: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
}));
